import React, { useState } from 'react';
import { Button, Dialog, DialogActions, DialogContent, DialogTitle, MenuItem, Select, FormControl, InputLabel } from '@mui/material';
import { printReport } from  "../utils/exportUtils";
import { ExportColumn } from "../template/exportReportTemplate";

interface PrintDialogProps {
  open: boolean;
  onClose: () => void;
  data: any[];
  exportColumns: ExportColumn[];
  reportTitle: string;
  reportDate: string;
}

const PrintDialog: React.FC<PrintDialogProps> = ({
  open,
  onClose,
  data,
  exportColumns,
  reportTitle,
  reportDate
}) => {
  const [pageSize, setPageSize] = useState<'a4' | 'letter' >('a4');
  const [pageOrientation, setPageOrientation] = useState<'portrait' | 'landscape'>('portrait');

  const handlePrint = () => {
    printReport(data, exportColumns, reportTitle, reportDate, pageSize, pageOrientation);
    onClose();
  };

  return (
    <Dialog open={open} onClose={onClose}>
      <DialogTitle>Print</DialogTitle>
      <DialogContent>
        <p>We'll create a printer-friendly PDF version of your report.</p>
        <FormControl fullWidth margin="normal">
          <InputLabel>Page size</InputLabel>
          <Select value={pageSize} onChange={(e) => setPageSize(e.target.value as 'a4' | 'letter')}>
            <MenuItem value="a4">A4</MenuItem>
            <MenuItem value="letter">Letter</MenuItem>
            
          </Select>
        </FormControl>
        <FormControl fullWidth margin="normal">
          <InputLabel>Page orientation</InputLabel>
          <Select value={pageOrientation} onChange={(e) => setPageOrientation(e.target.value as 'portrait' | 'landscape')}>
            <MenuItem value="portrait">Portrait</MenuItem>
            <MenuItem value="landscape">Landscape</MenuItem>
          </Select>
        </FormControl>
      </DialogContent>
      <DialogActions>
        <Button onClick={handlePrint} color="primary">Print</Button>
        <Button onClick={onClose} color="secondary">Cancel</Button>
      </DialogActions>
    </Dialog>
  );
};

export default PrintDialog;
